/**
 * ! 筛选{param}参数
 */
export function sift_query_list(query) {
	const query_ = {};
	for (const param in query) {
		if ([null, undefined, ''].indexOf(query[param]) !== -1) continue;
		query_[param] = query[param];
	}

	return query_;
}